// @flow
import {history} from 'client/history';

type makeLinkRowPropsType = () => {
  role: string,
  onClick: (e: SyntheticEvent<*>) => void,
  href: string,
  className: string
};

/**
 * Helper method for making <Table> rows act as links.
 *
 * @example
 * <Table
 *   data={fromJS([{
 *     name: 'foo',
 *     id: 1
 *   }, {
 *     name: 'bar',
 *     id: 2
 *   }])}
 *   rowPropsFunc={makeLinkRowProps((item) => `/path/to/thing/${item.get('id')}`)}
 * >
 *   ...
 * </Table>
 *
 * @param {function} makeHrefFunc
 */
// eslint-disable-next-line import/prefer-default-export
export function makeLinkRowProps(makeHrefFunc: () => string): makeLinkRowPropsType {
  return (item: any) => {
    const hrefValue = makeHrefFunc(item);
    // This allows for conditional rendering of a clickable row.
    // An example can be found in `folders.react`
    if (!hrefValue) {
      return {
        className: 'sg-table__tr--link'
      };
    }
    return {
      role: 'link',
      onClick: (e) => history.pushState(null, e.currentTarget.getAttribute('href')),
      href: hrefValue,
      className: 'sg-table__tr--link'
    };
  };
}
